import React from "react";
import { FaQuoteLeft } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import "./Testimonials.css";

const homeClientTestimonials = [
  {
    name: "Omer Abdulla",
    role: "Real Estate Client, Dubai (UAE)",
    quote:
      "Oglitz helped us build a strong digital presence with a clean, modern website that perfectly represents our real estate brand in Dubai.",
  },
  {
    name: "Reema Steel",
    role: "Industrial Manufacturing, Dubai",
    quote:
      "Professional execution and timely delivery. Our corporate website now clearly showcases our industrial capabilities.",
  },
  {
    name: "Octavian GR",
    role: "Enterprise Client, United Kingdom",
    quote:
      "Professional, secure, and enterprise-ready development. The collaboration was smooth and efficient.",
  },
  {
    name: "Trippr",
    role: "Startup Founder, India",
    quote:
      "Oglitz played a key role in shaping our platform and delivering a smooth user experience.",
  },
  {
    name: "Crypto App Client",
    role: "Blockchain Startup, USA",
    quote:
      "Strong understanding of modern technologies and secure application development.",
  },
  {
    name: "Confidential Client",
    role: "NDA Project, Germany",
    quote:
      "Handled with complete confidentiality and delivered a robust, scalable solution.",
  },
];

const Testimonials = () => {
  return (
    <section className="oglitz-home-client-testimonials">
      <div className="oglitz-home-client-inner">
        <span className="oglitz-home-client-badge">Client Testimonials</span>

        <h2 className="oglitz-home-client-title">
          Trusted by <span>Global Clients</span>
        </h2>

        <p className="oglitz-home-client-desc">
          Real feedback from startups, enterprises, and businesses across India,
          Dubai, Europe, and global markets.
        </p>

        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={32}
          slidesPerView={3}
          loop
          speed={10000} // 🔥 smooth transition speed
          autoplay={{
            delay: 0, // 🔥 continuous scroll
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="oglitz-home-client-swiper"
        >
          {homeClientTestimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="oglitz-home-client-card">
                <FaQuoteLeft className="oglitz-home-client-quote" />

                <p className="oglitz-home-client-text">{item.quote}</p>

                <div className="oglitz-home-client-author">
                  <strong>{item.name}</strong>
                  <span>{item.role}</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Testimonials;
